import { Fragment, useState } from 'react'
import classNames from 'classnames'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import Typography from '@/components/base/Typography'

type TabProps = Partial<{
  label: string
  children: React.ReactNode
}>

type TabsProps = {
  children: React.ReactElement<TabProps>[] | any
}

const Tab: React.FC<TabProps> = ({ children }) => {
  return children
}

const Tabs: React.FC<TabsProps> = ({ children, ...props }) => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabClick = (index: number) => {
    setActiveTab(index)
    ScrollTrigger.refresh(true)
  }

  return (
    <>
      <div
        className="flex items-center self-stretch overflow-x-auto scrollbar-hide"
        {...props}
      >
        {children.map((tab: React.ReactElement<TabProps>, index: number) => (
          <Fragment key={index}>
            <div className="shrink-0">
              <button
                type="button"
                className="flex h-[34px] select-none items-center whitespace-nowrap"
                onClick={() => handleTabClick(index)}
              >
                <Typography
                  variant="subtitle"
                  component="span"
                  className={classNames(
                    'uppercase transition-colors duration-200',
                    {
                      'text-blue-soft': index === activeTab
                    },
                    {
                      'text-neutral-75': index !== activeTab
                    }
                  )}
                >
                  {tab.props.label}
                </Typography>
              </button>
            </div>
            {index < children.length - 1 ? (
              <span className="px-xs text-neutral-75">-</span>
            ) : null}
          </Fragment>
        ))}
      </div>
      <div className="tab-content">{children[activeTab]}</div>
    </>
  )
}

export { Tab, Tabs }
